/** Lowercased, accent-stripped — for accent-insensitive substring search. */
export function normalize(s) {
    return s
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}
/** Wrap matches of `query` (accent-insensitive) with `<mark>` in `text`. */
export function highlight(text, query) {
    const escaped = escapeHtml(text);
    const tokens = normalize(query).split(' ').filter(Boolean);
    if (!tokens.length)
        return { __html: escaped };
    const re = new RegExp('(' +
        tokens
            .map((t) => t
            .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
            .split('')
            .map((c) => accentClass(c))
            .join(''))
            .join('|') +
        ')', 'gi');
    return { __html: escaped.replace(re, '<mark>$1</mark>') };
}
function accentClass(c) {
    const map = {
        a: '[aáàäâãAÁÀÄÂÃ]',
        e: '[eéèëêEÉÈËÊ]',
        i: '[iíìïîIÍÌÏÎ]',
        o: '[oóòöôõOÓÒÖÔÕ]',
        u: '[uúùüûUÚÙÜÛ]',
        n: '[nñNÑ]',
    };
    return map[c.toLowerCase()] ?? c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function escapeHtml(s) {
    return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
//# sourceMappingURL=normalize.js.map